import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

function Header({ sx, children }) {
    return jsx(Wrapper, { sx: sx, children: children });
}
const Wrapper = styled("header")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.ui50}`,
    backgroundColor: theme.palette.ui25,
    padding: theme.spacing(2, 0),
    justifyContent: "center",
}));

export { Header };
//# sourceMappingURL=Wrapper.js.map
